<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<el-select v-model="dateType" style="width: 130px;margin-right: 5px;" size='small'>
					<el-option value="3" label="全部时间"></el-option>
					<el-option value="1" label="支付时间"></el-option>
					<el-option value="2" label="退款申请时间"></el-option>
					<el-option value="4" label="退款完成时间"></el-option>
				</el-select>
				<el-date-picker
					v-model="dateValue"
					size="small"
					:clearable="false"
					type="datetimerange"
					align="right"
					style="width:435px"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<div class="order-type-box">
				<span>支付方式：</span>
				<el-select v-model="paymentmode" multiple collapse-tags placeholder="请选择支付方式" class="order-type-select" size="small" @change="paymentmodeChange">
					<!-- <el-option label="全部" value="全部"></el-option> -->
					<el-option label="微信支付" value="微信支付"></el-option>
					<el-option label="线下支付" value="线下支付"></el-option>
					<el-option label="微信充值" value="微信充值"></el-option>
					<el-option label="线下充值" value="线下充值"></el-option>
					<el-option label="微企付充值" value="微企付充值"></el-option>
					<el-option label="B2b门店助手-微信支付充值" value="B2b门店助手-微信支付充值"></el-option>
					<el-option label="B2b门店助手-银行转账充值" value="B2b门店助手-银行转账充值"></el-option>
					<el-option label="预付货款支付" value="预付货款支付"></el-option>
					<el-option label="微企付支付" value="微企付支付"></el-option>
					<el-option label="手动扣减" value="手动扣减"></el-option>
					<el-option label="云资金-网商余额支付" value="云资金-网商余额支付"></el-option>
					<el-option label="云资金-汇付支付" value="云资金-汇付支付"></el-option>
					<el-option label="云资金-中信支付" value="云资金-中信支付"></el-option>
					<el-option label="云资金-富友账户通支付" value="云资金-富友账户通支付"></el-option>
					<el-option label="B2b门店助手-微信支付" value="B2b门店助手-微信支付"></el-option>
					<el-option label="B2b门店助手-银行转账" value="B2b门店助手-银行转账"></el-option>
					<el-option label="云资金-网商收银台" value="云资金-网商收银台"></el-option>
					<el-option label="拉卡拉全渠道-余额支付" value="拉卡拉全渠道-余额支付"></el-option>
					<el-option label="拉卡拉钱包余额" value="拉卡拉钱包余额"></el-option>
					<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--					<el-option label="拉卡拉全渠道-收银台" value="拉卡拉全渠道-收银台"></el-option>-->
				</el-select>
			</div>
			<div class="order-type-box checkbox-box" v-show="paymentmode.length > 0">
				<el-checkbox :true-label='1' :false-label='0' v-model="selected">
					<span>统计已取消订单</span>
				</el-checkbox>
			</div>
			<div class="order-type-box">
				<span>退款方式：</span>
				<el-select v-model="refundpaymentmode" multiple collapse-tags placeholder="请选择退款方式" class="order-type-select" size="small">
					<el-option label="线下退款" value="线下退款"></el-option>
					<el-option label="微信退回账户余额（预付货款）" value="微信退回账户余额（预付货款）"></el-option>
					<el-option label="微信原路退回" value="微信原路退回"></el-option>
					<el-option label="微企付退回账户余额（预付货款）" value="微企付退回账户余额（预付货款）"></el-option>
					<el-option label="微企付原路退回" value="微企付原路退回"></el-option>
					<el-option label="退回账户余额" value="退回账户余额"></el-option>
					<el-option label="云资金-网商余额支付原路退回" value="云资金-网商余额支付原路退回"></el-option>
					<el-option label="云资金-汇付支付原路退回" value="云资金-汇付支付原路退回"></el-option>
					<el-option label="云资金-中信支付原路退回" value="云资金-中信支付原路退回"></el-option>
					<el-option label="云资金-富友账户通支付原路退回" value="云资金-富友账户通支付原路退回"></el-option>
					<el-option label="B2b门店助手-微信支付原路退回" value="B2b门店助手-微信支付原路退回"></el-option>
					<el-option label="B2b门店助手-微信支付退回账户余额（预付货款）" value="B2b门店助手-微信支付退回账户余额（预付货款）"></el-option>
					<el-option label="B2b门店助手-银行转账原路退回" value="B2b门店助手-银行转账原路退回"></el-option>
					<el-option label="B2b门店助手-银行转账退回账户余额（预付货款）" value="B2b门店助手-银行转账退回账户余额（预付货款）"></el-option>
					<el-option label="云资金-网商收银台原路退回" value="云资金-网商收银台原路退回"></el-option>
					<el-option label="拉卡拉全渠道-余额支付原路退回" value="拉卡拉全渠道-余额支付原路退回"></el-option>
					<el-option label="拉卡拉钱包余额原路退回" value="拉卡拉钱包余额原路退回"></el-option>
					<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--					<el-option label="拉卡拉全渠道-收银台原路退回" value="拉卡拉全渠道-收银台原路退回"></el-option>-->
				</el-select>
			</div>
			<div class="order-type-box">
				<span>退单类型：</span>
				<el-select v-model="refundtype" multiple collapse-tags placeholder="请选择退单类型" class="order-type-select" size="small">
					<el-option label="自动" value="自动"></el-option>
					<el-option label="自动（订单取消）" value="自动（订单取消）"></el-option>
					<el-option label="手动" value="手动"></el-option>
				</el-select>
			</div>
			<div class="order-name-box">
				<span>客户名称：</span>
				<el-input v-model="customername" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>客户编号：</span>
				<el-input v-model="customercode" placeholder="请输入客户编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>客户类别：</span>
				<el-select v-model="customercategoryids" filterable multiple collapse-tags class="order-type-select" size='small'>
					<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
			<div class="order-NO-box">
				<span>单据编号：</span>
				<el-input v-model="number" placeholder="请输入单据编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>备注：</span>
				<el-input v-model="memo" placeholder="请输入备注" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>极速订支付流水号：</span>
				<el-input v-model="paymentserialnumber" placeholder="请输入极速订支付流水号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>第三方订单支付流水号：</span>
				<el-input v-model="paymentnumber" placeholder="请输入第三方订单支付流水号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>收款主体商编：</span>
				<el-input v-model="payeeAccountNo" placeholder="请输入收款主体商编" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			dateValue: [],
			dateType: '3',
			shopids: [],
			shopList: [],
			customername: '',
			customercode: '',
			customersyscoe: '',
			number: '',
			memo: '',
			paymentserialnumber: '',
			paymentnumber: '',
			payeeAccountNo: '',
			paymentmode: [],
			selected: 0,
			refundpaymentmode: [],
			refundtype: [],
			type: [],
			customercategoryids: [],
			customList: [],
			collapse: true
		}
	},
	created () {
		this.initFilters()
		this.getCustomer()
		this.getShopList()
	},
	methods: {
		paymentmodeChange () {
			if (this.paymentmode.length === 0) {
				this.selected = 0
			}
		},
		clearSearch () {
			this.shopids = []
			this.paymentmode = []
			this.selected = 0
			this.refundpaymentmode = []
			this.refundtype = []
			this.dateType = '3'
			this.memo = ''
			this.number = ''
			this.customername = ''
			this.customersyscoe = ''
			this.paymentnumber = ''
			this.payeeAccountNo = ''
			this.paymentserialnumber = ''
			this.customercode = ''
			this.customercategoryids = []
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			}
		},
		getFiltersDate () {
		},
		getFiltersParams () {
			let filtersParams = []
			if (this.dateValue && this.dateValue.length > 0) {
				filtersParams = [
					{ field: 'beginDate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '下单时间' },
					{ field: 'endDate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '下单时间' }
				]
			}
			let dateType = { 'field': 'dateType', 'data': this.dateType, 'op': 'eq' }
			filtersParams.push(dateType)
			if (this.shopids.length > 0) {
				let data = this.shopids.join(',')
				let shopObj = { 'field': 'shopid', 'data': data, 'op': 'in' }
				filtersParams.push(shopObj)
			}
			if (this.paymentmode.length !== 0) {
				let paymentmodeObj = { 'field': 'paymentmode', 'data': this.paymentmode, 'op': 'in' }
				filtersParams.push(paymentmodeObj)
				let selectedObj = { 'field': 'selected', 'data': this.selected, 'op': 'eq' }
				filtersParams.push(selectedObj)
			}
			if (this.refundpaymentmode.length !== 0) {
				let refundpaymentmodeObj = { 'field': 'refundpaymentmode', 'data': this.refundpaymentmode, 'op': 'in' }
				filtersParams.push(refundpaymentmodeObj)
			}
			if (this.refundtype.length !== 0) {
				let refundtypeObj = { 'field': 'refundtype', 'data': this.refundtype, 'op': 'in' }
				filtersParams.push(refundtypeObj)
			}
			if (this.type.length !== 0) {
				let typeObj = { 'field': 'type', 'data': this.type.join(','), 'op': 'in' }
				filtersParams.push(typeObj)
			}
			if (this.customername) {
				let customernameObj = { 'field': 'customername', 'data': this.customername, 'op': 'cn' }
				filtersParams.push(customernameObj)
			}
			if (this.customercode) {
				let customercodeObj = { 'field': 'customercode', 'data': this.customercode, 'op': 'cn' }
				filtersParams.push(customercodeObj)
			}
			if (this.customersyscoe) {
				let customersyscoeObj = { 'field': 'customersyscoe', 'data': this.customersyscoe, 'op': 'cn' }
				filtersParams.push(customersyscoeObj)
			}
			if (this.customercategoryids.length !== 0) {
				let customercategoryids = { 'field': 'customercategoryids', 'data': this.customercategoryids.join(','), 'op': 'in' }
				filtersParams.push(customercategoryids)
			}
			if (this.number) {
				let numberObj = { 'field': 'number', 'data': this.number, 'op': 'cn' }
				filtersParams.push(numberObj)
			}
			if (this.memo) {
				let memoObj = { 'field': 'memo', 'data': this.memo, 'op': 'cn' }
				filtersParams.push(memoObj)
			}
			if (this.paymentserialnumber) {
				let paymentserialnumberObj = { 'field': 'paymentserialnumber', 'data': this.paymentserialnumber, 'op': 'cn' }
				filtersParams.push(paymentserialnumberObj)
			}

			if (this.paymentnumber) {
				let paymentnumber = { 'field': 'paymentnumber', 'data': this.paymentnumber, 'op': 'cn' }
				filtersParams.push(paymentnumber)
			}
			if (this.payeeAccountNo) {
				let payeeAccountNo = { 'field': 'payeeAccountNo', 'data': this.payeeAccountNo, 'op': 'cn' }
				filtersParams.push(payeeAccountNo)
			}
			return {
				filtersParams
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 135px;
				text-align: right
			}
		}
		.checkbox-box {
			display: flex;
			align-items: center;
			margin-left: 10px;
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
